import { useState } from 'react';
import Modal from '../../components/Modal/Modal';
import Select from '../../components/Select/Select';
import Button from '../../components/Button/Button';
import editDeal from '../../api/deals/editDeal';
import { DEAL_STATUS_REJECTED } from '../../constants';
import alert from '../../helpers/alert';
import LoaderInline from '../../components/Loader/LoaderInline';
import setStep from '../../api/deals/setStep';

const REJECT_REASONS = [
  { label: 'ÐÑÐºÐ°Ð·Ð°Ð»Ð¸ Ð²ÑÐµ Ð±Ð°Ð½ÐºÐ¸', value: 'rejected_all_banks' },
  { label: 'ÐÑÐºÐ°Ð·Ð°Ð» Ð½ÑÐ¶Ð½ÑÐ¹ Ð±Ð°Ð½Ðº', value: 'rejected_specific_bank' },
  { label: 'ÐÐ»Ð¸ÐµÐ½Ñ Ð¾ÑÐºÐ°Ð·Ð°Ð»ÑÑ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÑ Ð°Ð²ÑÐ¾', value: 'client_refused_to_buy_car' },
  { label: 'Ð£ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð½ÐµÑ Ð´ÐµÐ½ÐµÐ³ Ð½Ð° ÐÐ', value: 'client_has_no_money_for_PV' },
];

const RejectDealModal = ({ isOpen, onClose, dealId, onSuccess }) => {
  const [reason, setReason] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!reason) {
      return setError('ÐÐ¾Ð»Ðµ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ');
    } else {
      setError(null);
    }

    try {
      setLoading(true);
      await editDeal({
        id: dealId,
        statusId: DEAL_STATUS_REJECTED,
        step: 10,
        cancelDescription: reason?.label,
      });
      await setStep({dealId, step: 10});

      alert.success("Ð¡Ð´ÐµÐ»ÐºÐ° ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐºÐ»Ð¾Ð½ÐµÐ½Ð°")
      onClose && onClose(false);
      onSuccess && onSuccess();
    } catch (e) {
      alert.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      title={`Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¿ÑÐ¸ÑÐ¸Ð½Ñ, Ð¿Ð¾ ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ ÑÐ´ÐµÐ»ÐºÐ° â${dealId} ÑÑÐ¸ÑÐ°ÐµÑÑÑ Ð½ÐµÑÐ´Ð°ÑÐ½Ð¾Ð¹`}
      onRequestClose={() => onClose(false)}
      contentStyle={{
        top: '20%',
        height: 'fit-content',
        width: 500,
      }}
    >
      {loading ? (
        <LoaderInline />
      ) : (
        <div
          style={{
            display: 'grid',
            gap: 20,
          }}
        >
          <div>
            <Select
              error={error}
              placeholder="ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ"
              label="ÐÑÐ¸ÑÐ¸Ð½Ð°"
              required
              options={REJECT_REASONS}
              onChange={setReason}
            />
            {error && (
              <div
                style={{
                  fontWeight: 300,
                  fontSize: '11px',
                  lineHeight: '20px',
                  color: '#EB5757',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  marginTop: '4px',
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <g clipPath="url(#clip0_3320_14643)">
                    <path
                      d="M8.00016 14.6666C4.31816 14.6666 1.3335 11.682 1.3335 7.99998C1.3335 4.31798 4.31816 1.33331 8.00016 1.33331C11.6822 1.33331 14.6668 4.31798 14.6668 7.99998C14.6668 11.682 11.6822 14.6666 8.00016 14.6666ZM8.00016 13.3333C9.41465 13.3333 10.7712 12.7714 11.7714 11.7712C12.7716 10.771 13.3335 9.41447 13.3335 7.99998C13.3335 6.58549 12.7716 5.22894 11.7714 4.22874C10.7712 3.22855 9.41465 2.66665 8.00016 2.66665C6.58567 2.66665 5.22912 3.22855 4.22893 4.22874C3.22873 5.22894 2.66683 6.58549 2.66683 7.99998C2.66683 9.41447 3.22873 10.771 4.22893 11.7712C5.22912 12.7714 6.58567 13.3333 8.00016 13.3333ZM7.3335 9.99998H8.66683V11.3333H7.3335V9.99998ZM7.3335 4.66665H8.66683V8.66665H7.3335V4.66665Z"
                      fill="#EB5757"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3320_14643">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{error}</span>
              </div>
            )}
          </div>
          <Button fill full onClick={handleSubmit}>
            ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default RejectDealModal;
